export default [
  {
    labelText: 'Accommodation and Food Service Activities',
    id: 'Accommodation and Food Service Activities',
    children: [
      { labelText: 'Alcoholic and soft drinks', id: 'Alcoholic and soft drinks' },
      { labelText: 'Hotel trade', id: 'Hotel trade' },
      {
        labelText: 'Other tourist and short stay accommodation',
        id: 'Other tourist and short stay accommodation'
      },
      {
        labelText: 'Public houses, bars, night clubs and licensed clubs',
        id: 'Public houses, bars, night clubs and licensed clubs'
      },
      {
        labelText: 'Restaurants and other eating places',
        id: 'Restaurants and other eating places'
      }
    ]
  },
  {
    labelText: 'Agriculture, Fishing & Forestry',
    id: 'Agriculture, Fishing & Forestry',
    children: [
      {
        labelText: 'Agriculture: Farmers (owner-occupiers)',
        id: 'Agriculture: Farmers (owner-occupiers)'
      },
      { labelText: 'Agriculture: Farmers (tenants)', id: 'Agriculture: Farmers (tenants)' },
      {
        labelText: 'Agriculture: Horticulturists and nurserymen (owner-occupiers)',
        id: 'Agriculture: Horticulturists and nurserymen (owner-occupiers)'
      },
      {
        labelText: 'Agriculture: Horticulturists and nurserymen (tenants)',
        id: 'Agriculture: Horticulturists and nurserymen (tenants)'
      },
      { labelText: 'Agriculture; other agricultural', id: 'Agriculture; other agricultural' },
      { labelText: 'Fishing', id: 'Fishing' },
      { labelText: 'Forestry', id: 'Forestry' }
    ]
  },
  {
    labelText: 'Computer and technology services',
    id: 'Computer and technology services',
    children: [
      {
        labelText: 'Business and domestic software development',
        id: 'Business and domestic software development'
      },
      { labelText: 'Computer consultancy activities', id: 'Computer consultancy activities' },
      {
        labelText: 'Computer facilities management activities',
        id: 'Computer facilities management activities'
      },
      {
        labelText: 'Data processing, hosting and related activities',
        id: 'Data processing, hosting and related activities'
      },
      {
        labelText: 'Other information technology and computer service activities',
        id: 'Other information technology and computer service activities'
      },
      { labelText: 'Other software publishing', id: 'Other software publishing' },
      { labelText: 'Publishing of computer games', id: 'Publishing of computer games' },
      {
        labelText: 'Ready-made interactive leisure and entertainment software development',
        id: 'Ready-made interactive leisure and entertainment software development'
      },
      { labelText: 'Web portals', id: 'Web portals' }
    ]
  },
  {
    labelText: 'Construction',
    id: 'Construction',
    children: [
      { labelText: 'Civil engineering', id: 'Civil engineering' },
      {
        labelText: 'Construction of commercial buildings',
        id: 'Construction of commercial buildings'
      },
      {
        labelText: 'Construction of domestic buildings',
        id: 'Construction of domestic buildings'
      },
      {
        labelText:
          'Development of buildings (Includes, joiners, electricians, painters and decorators, plumbers, carpet fitters)',
        id:
          'Development of buildings (Includes, joiners, electricians, painters and decorators, plumbers, carpet fitters)'
      },
      { labelText: 'Other construction activities', id: 'Other construction activities' }
    ]
  },
  {
    labelText: 'Education',
    id: 'Education',
    children: [{ labelText: 'Educational services', id: 'Educational services' }]
  },
  {
    labelText: 'Entertainment Services',
    id: 'Entertainment Services',
    children: [
      { labelText: 'Film and associated services', id: 'Film and associated services' },
      { labelText: 'Publishing', id: 'Publishing' },
      { labelText: 'Radio & TV', id: 'Radio & TV' }
    ]
  },
  {
    labelText: 'Finance and Insurance',
    id: 'Finance and Insurance',
    children: [
      { labelText: 'Executors and trustee services', id: 'Executors and trustee services' },
      {
        labelText: 'Other auxiliary activities - central clearing parties',
        id: 'Other auxiliary activities - central clearing parties',
        businessType: 'LimitedCompany'
      },
      {
        labelText: 'Other auxiliary activities - Excl central clearing parties',
        id: 'Other auxiliary activities - Excl central clearing parties',
        businessType: 'LimitedCompany'
      }
    ]
  },
  {
    labelText: 'Healthcare and Social Work',
    id: 'Healthcare and Social Work',
    children: [
      { labelText: 'Dentists', id: 'Dentists' },
      { labelText: 'Doctors and surgeons', id: 'Doctors and surgeons' },
      {
        labelText: 'Nursing, rest and sheltered homes',
        id: 'Nursing, rest and sheltered homes'
      },
      {
        labelText:
          'Other social services inc. charity activities (Includes, midwives, physiotherapists, chiropody, acupuncture, ambulance services)',
        id:
          'Other social services inc. charity activities (Includes, midwives, physiotherapists, chiropody, acupuncture, ambulance services)'
      },
      { labelText: 'Veterinary surgeons', id: 'Veterinary surgeons' }
    ]
  },
  {
    labelText: 'Manufacturing',
    id: 'Manufacturing',
    children: [
      { labelText: 'Chemical industry', id: 'Chemical industry' },
      {
        labelText: 'Electrical and electronic engineering',
        id: 'Electrical and electronic engineering'
      },
      { labelText: 'Food processing', id: 'Food processing' },
      {
        labelText: 'Manufacture of non-metallic mineral products',
        id: 'Manufacture of non-metallic mineral products'
      },
      { labelText: 'Mechanical engineering', id: 'Mechanical engineering' },
      { labelText: 'Metal manufacturing', id: 'Metal manufacturing' },
      { labelText: 'Motor vehicles', id: 'Motor vehicles' },
      {
        labelText: 'Other engineering and metal goods',
        id: 'Other engineering and metal goods'
      },
      { labelText: 'Other manufacturing', id: 'Other manufacturing' },
      { labelText: 'Other transport equipment', id: 'Other transport equipment' },
      { labelText: 'Pulp, paper and printing', id: 'Pulp, paper and printing' },
      {
        labelText: 'Textiles, leather, clothing and footwear',
        id: 'Textiles, leather, clothing and footwear'
      },
      { labelText: 'Tobacco industry', id: 'Tobacco industry' }
    ]
  },
  {
    labelText: 'Mining and Quarrying',
    id: 'Mining and Quarrying',
    children: [
      {
        labelText: 'Coal extraction & manufacture of solid fuels',
        id: 'Coal extraction & manufacture of solid fuels'
      },
      {
        labelText: 'Extraction of mineral oil & natural gas',
        id: 'Extraction of mineral oil & natural gas'
      },
      {
        labelText: 'Extraction of minerals & oils (other than fuels)',
        id: 'Extraction of minerals & oils (other than fuels)'
      },
      {
        labelText: 'Processing of mineral oil & natural gas',
        id: 'Processing of mineral oil & natural gas'
      }
    ]
  },
  {
    labelText: 'Professional services',
    id: 'Professional services',
    children: [
      { labelText: 'Advertising services', id: 'Advertising services' },
      { labelText: 'Architects', id: 'Architects' },
      { labelText: 'Chartered accountants', id: 'Chartered accountants' },
      { labelText: 'Other accounting services', id: 'Other accounting services' },
      {
        labelText:
          'Other business services (Includes call centres, recruitment, photography, training, consultancy, private security services)',
        id:
          'Other business services (Includes call centres, recruitment, photography, training, consultancy, private security services)'
      },
      { labelText: 'Other legal services', id: 'Other legal services' },
      {
        labelText: 'Real estate, professional services and support - cleaning',
        id: 'Real estate, professional services and support - cleaning'
      },
      { labelText: 'Research and development', id: 'Research and development' },
      { labelText: 'Solicitors', id: 'Solicitors' }
    ]
  },
  {
    labelText: 'Real Estate, Renting and Housing Associations',
    id: 'Real Estate, Renting and Housing Associations',
    children: [
      { labelText: 'Hiring of moveables', id: 'Hiring of moveables' },
      { labelText: 'House and estate agents', id: 'House and estate agents' },
      {
        labelText: 'Housing associations',
        id: 'Housing associations',
        businessType: 'LimitedCompany'
      },
      { labelText: 'Other property companies', id: 'Other property companies' },
      { labelText: 'Travel agents and tour operators', id: 'Travel agents and tour operators' }
    ]
  },
  {
    labelText: 'Recreational, Personal and Community Service Activities',
    id: 'Recreational, Personal and Community Service Activities',
    children: [
      { labelText: 'Artists, authors and composers', id: 'Artists, authors and composers' },
      {
        labelText:
          'Betting and sport (Includes, sports promoters, racing stables, hunting, betting shops, amusement arcades)',
        id:
          'Betting and sport (Includes, sports promoters, racing stables, hunting, betting shops, amusement arcades)'
      },
      { labelText: 'Other community services', id: 'Other community services' },
      {
        labelText:
          'Rec, per and community services - cleaning (Includes, dry cleaning, laundering, window cleaners, car valeting)',
        id:
          'Rec, per and community services - cleaning (Includes, dry cleaning, laundering, window cleaners, car valeting)'
      },
      { labelText: 'Trade associations', id: 'Trade associations' }
    ]
  },
  {
    labelText: 'Transport and Storage',
    id: 'Transport and Storage',
    children: [
      { labelText: 'Air transport', id: 'Air transport' },
      { labelText: 'Other transport', id: 'Other transport' },
      { labelText: 'Road haulage', id: 'Road haulage' },
      { labelText: 'Warehousing and storage', id: 'Warehousing and storage' }
    ]
  },
  {
    labelText: 'Utilities, Post & Telecoms',
    id: 'Utilities, Post & Telecoms',
    children: [
      { labelText: 'Communication Activities', id: 'Communication Activities' },
      { labelText: 'Postal services', id: 'Postal services' },
      {
        labelText: 'Production & distribution of electricity',
        id: 'Production & distribution of electricity'
      },
      {
        labelText: 'Production & distribution of other forms of energy',
        id: 'Production & distribution of other forms of energy'
      },
      { labelText: 'Public gas supply', id: 'Public gas supply' },
      { labelText: 'Refuse disposal', id: 'Refuse disposal' },
      { labelText: 'Water supplies', id: 'Water supplies' }
    ]
  },
  {
    labelText: 'Wholesale and Retail Trade',
    id: 'Wholesale and Retail Trade',
    children: [
      {
        labelText: 'Confectioners, tobacconists, newsagents & off licences',
        id: 'Confectioners, tobacconists, newsagents & off licences'
      },
      { labelText: 'Food retailing', id: 'Food retailing' },
      {
        labelText: 'Garages and sale and repair of motor vehicles',
        id: 'Garages and sale and repair of motor vehicles'
      },
      { labelText: 'Other retail distribution', id: 'Other retail distribution' },
      { labelText: 'Repair of consumer goods', id: 'Repair of consumer goods' },
      {
        labelText: 'Wholesale distribution: livestock salesman',
        id: 'Wholesale distribution: livestock salesman'
      },
      {
        labelText: 'Wholesale distribution: others (Includes importing and exporting businesses)',
        id: 'Wholesale distribution: others (Includes importing and exporting businesses)'
      }
    ]
  }
];
